import React from 'react';
import { Link } from 'react-router-dom';
import { Compass } from 'lucide-react';

/**
 * Catch-all for unmatched URLs.
 *
 * Without this an unknown path rendered an empty <main>, so a mistyped link -
 * or a stale bundle that has not yet learnt a new route - looked identical to
 * the app being broken.
 */
const NotFound: React.FC = () => (
  <div className="min-h-[60vh] flex items-center justify-center px-4">
    <div className="relative w-full max-w-md overflow-hidden rounded-2xl border border-blue-100 bg-white shadow-sm">
      <div className="pointer-events-none absolute inset-0 bg-gradient-to-br from-blue-50/70 via-white to-white" />

      <div className="relative flex flex-col items-center px-6 py-14 text-center">
        <div className="mb-5 flex h-14 w-14 items-center justify-center rounded-2xl
                        bg-blue-50 text-blue-500 ring-1 ring-blue-100">
          <Compass className="w-7 h-7" />
        </div>

        <span className="mb-3 text-[10px] font-medium uppercase tracking-[0.2em] text-blue-500">
          Page not found
        </span>

        <h1 className="mb-3 text-2xl font-semibold tracking-tight text-gray-900">
          We couldn't find that page
        </h1>

        <p className="mb-7 max-w-sm text-sm font-light leading-relaxed text-gray-500">
          The link may be out of date, or the page may have moved.
        </p>

        <Link
          to="/"
          className="rounded-lg bg-blue-50 px-5 py-2.5 text-sm font-medium text-blue-600
                     transition-colors duration-200 hover:bg-blue-100"
        >
          Back to venues
        </Link>
      </div>
    </div>
  </div>
);

export default NotFound;
